define('drops/radioButtonGroup/radioButtonGroup',[
    'jquery',
    'lq/drop',
    'lq/util',
    'underscore'
], function ($, Drop, util, _) {
    'use strict';

    var defaults = {
        data: {
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function RadioButtonGroup(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.value = this.data.value;
    };

    Drop.extend(RadioButtonGroup, Drop);

    RadioButtonGroup.typeName = 'RadioButtonGroup';

    // WHY: The old morph code didn't apply the position correctly
    // and we need to stay compatible with actions that were created in the
    // old morphs designer. This means there's actually a discrepancy
    // between the position of radiobuttons and all other drops.
    RadioButtonGroup.prototype.applyPosition = $.noop;

    RadioButtonGroup.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.$element
            .css({
                position: 'absolute',
                zIndex: this.data.zIndex
            });
    };

    RadioButtonGroup.prototype.postRender = function () {
        this.addRequiredIndicator();
        this.updateRequiredIndicator();
    };

    RadioButtonGroup.prototype.addRequiredIndicator = function () {
        if (this.pool.length === 0)
            return;

        if (this.data.required)
            this.pool[0].$element.addClass('isRequiredField');
        else
            this.pool[0].$element.removeClass('isRequiredField');
    };

    RadioButtonGroup.prototype.updateRequiredIndicator = function () {
        if (this.pool.length === 0)
            return;

        if (this.isValid())
            this.pool[0].$element.addClass('hasValidValue');
        else
            this.pool[0].$element.removeClass('hasValidValue');
    };

    RadioButtonGroup.prototype.render = function ($element) {
    	return this.createAndRenderDrops($element);
    };

    RadioButtonGroup.prototype.radioButtonSelectionChanged = function (valueOfSelection) {
        if (this.value === valueOfSelection)
            return;

        this.value = valueOfSelection;

        // for now both events trigger are always triggered together
        this.triggerEventIfEnabled('selected', valueOfSelection);
        this.triggerEventIfEnabled('changed', valueOfSelection);

        this.updateRequiredIndicator();
    };

    RadioButtonGroup.prototype.getValue = function () {
        return this.value;
    };

    RadioButtonGroup.prototype.setValue = function (update) {
        var value = update.value === null || update.value === undefined ? update.value : update.value.toString();
        var radioButton = _.find(this.pool, function(drop) {
            return drop.data.value === value;
        });
        if (radioButton) {
            this.value = value;
            radioButton.select();
        } else {
            this.clearValue();
        }

        this.updateRequiredIndicator();
    };

    RadioButtonGroup.prototype.clearValue = function () {
        this.value = null;

        _.each(this.pool, function (drop) {
            drop.unselect();
        });

        this.updateRequiredIndicator();
    };

    return RadioButtonGroup;
});
